<template>
  <div class="success" v-if='orderInfo'>
    <div class="success-header">
        <div class="text-center info">
          <h1>Спасибо за покупку и приятного просмотра!</h1>
          <p>Информация о заказе отправлена на вашу почту или введите его в
            терминале по выдаче билетов.
          </p>
        </div>
        <div class="contact" v-if="orderInfo.Theatre && orderInfo.Theatre.supportPhone">
          <div class="contact-label">Служба поддержки</div>
          <div class="contact-number">{{ orderInfo.Theatre.supportPhone }}</div>
        </div>
      </div>
    <div class="success-body">
        <div class="success-body-wrapper">
          <div v-if='orderInfo.MovieOrder'
            class="success-session-wrapper"
            :style="{
              'background-image':
                'linear-gradient(to bottom, #000000b3 0%, #000000b3 100%), url(' +
                orderInfo.MovieOrder.ImageUrl +
                ')',
            }"
          >
            <div class="success-session-title" v-if="orderInfo.MovieOrder.SessionStart">
              {{ new Date(orderInfo.MovieOrder.SessionStart) | moment('dddd, D MMMM в H:mm') }}
            </div>
            <div class="success-session-footer">
              <div class="success-session-tags">
                <div class="tag" v-if="orderInfo.MovieOrder.Format">{{ orderInfo.MovieOrder.Format }}</div>
                <div class="tag">{{ `${orderInfo.MovieOrder.Rate}+` }}</div>
              </div>
              <div class="success-session-name">{{ orderInfo.MovieOrder.MovieName }}</div>
            </div>
          </div>
          <div class="cart-wrapper">
            <div class="cart-wrapper-inner">
              <div class="cart-scrollable success-scrollable">
                <div class="theatre-wrapper">
                  <div class="label">Площадка</div>
                  <div class="name">{{ orderInfo.Theatre.Name }}, {{ orderInfo.Theatre.HallName }}</div>
                  <div class="address">{{ orderInfo.Theatre.Address }}</div>
                </div>
                <div class="order-wrapper" v-if='orderInfo.MovieOrder && orderInfo.MovieOrder.OrderNumber'>
                  <div class="label">Номер заказа билетов</div>
                  <div class="order-number">{{ orderInfo.MovieOrder.OrderNumber }}</div>
                </div>
                <div class="qr-wrapper" v-if="orderInfo.MovieOrder && orderInfo.MovieOrder.OrderNumber">
                  <div class="desciption">
                    Приложите QR-код к считывающему устройству и получите входной билет
                  </div>
                  <div class="qr-code">
                    <qrcode
                      :value="orderInfo.MovieOrder.OrderNumber"
                      :options="{ size: 160 }"
                    ></qrcode>
                  </div>
                </div>
                <div class="success-cart cart-items">
                  <div class="cart-group cart-thicket" v-if="!this.movie.IsEventRegister && orderInfo.MovieOrder && orderInfo.MovieOrder.Places">
                    <div class="label">Билеты</div>
                    <div class="list">
                      <div
                        class="item"
                        v-for="(ticket, index) in orderInfo.MovieOrder.Places"
                        :key="index"
                      >
                        <span class="position">{{ticket.Row}} ряд, {{ ticket.Number }} место</span>
                        <span class="dots"></span>
                        <span class="price" v-if='ticket.Price'>{{ ticket.Price }}</span>
                        <span class="price" v-else>Бесплатно</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="order-wrapper" v-if="orderInfo.BarOrder && orderInfo.BarOrder.OrderNumber">
                  <div class="label">Номер заказа бара</div>
                  <div class="order-number">{{ orderInfo.BarOrder.OrderNumber }}</div>
                </div>
                <div class="qr-wrapper" v-if="orderInfo.BarOrder && orderInfo.BarOrder.OrderNumber">
                  <div class="desciption">
                    Приложите QR-код к считывающему устройству и получите заказ в
                    баре
                  </div>
                  <div class="qr-code">
                    <qrcode
                      :value="orderInfo.BarOrder.OrderNumber"
                      :options="{ size: 160 }"
                    ></qrcode>
                  </div>
                </div>
                <div class="success-cart cart-items" v-if="orderInfo.BarOrder && orderInfo.BarOrder.OrderNumber">
                  <div class="cart-group cart-bar" v-if="orderInfo.BarOrder && orderInfo.BarOrder.BarItems">
                    <div class="label">Бар</div>
                    <div class="list">
                      <div
                        class="item"
                        v-for="(item, index) in orderInfo.BarOrder.BarItems"
                        :key="index"
                      >
                        <span class="position">{{ item.ProductName }} ({{item.Quantity}})</span>
                        <span class="dots"></span>
                        <span class="price">{{getTotalPrice(item.Price, item.Quantity)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cart-total" v-if='cart'>
              <div class="cart-total-label label">Итого:</div>
              <div class="cart-total-price">
                {{ cart.sum }} {{ setting.currency }}
                <span v-if="user.paymentWithBonuses">
                  (-{{cart.spentBonuses.bar + cart.spentBonuses.tickets}} бонусов)
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="success-footer">
        <h4>С приложением - удобнее!</h4>
        <div class="info">Так же попробуйте наше мобильное приложение!</div>
        <div class="success-footer__link-items">
          <a
            href="https://itunes.apple.com/ru/app/%D0%BF%D1%80%D0%B5%D0%BC%D1%8C%D0%B5%D1%80-%D0%B7%D0%B0%D0%BB/id1251836829?mt=8"
          ><img src="/app-store.png" alt="Загрузить в AppStore"
          /></a>
          <a
            href="https://play.google.com/store/apps/details?id=ru.premierzal.apremier"
          ><img src="/play-market-2.png" alt="Загрузить в Play Market"
          /></a>
        </div>
      </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Success',

  computed: {
    ...mapState(['orderInfo', 'movie']),
  },

  mounted() {
    this.$store.dispatch('loadPageAfterPayment', this.$route.query)
    this.$router.replace({ query: null });
  },

  created() {},

  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
    },

    getTotalPrice(price, count) {
      return price * count;
    },
  },
};
</script>

<style src='./Success.scss' lang="scss"></style>
